import { render } from "./StudentDeclaration.vue?vue&type=template&id=e807e64a&scoped=true"
import script from "./StudentDeclaration.vue?vue&type=script&lang=js"
export * from "./StudentDeclaration.vue?vue&type=script&lang=js"

import "./StudentDeclaration.vue?vue&type=style&index=0&id=e807e64a&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e807e64a"]])

export default __exports__